import { z } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
// Extend Zod with OpenAPI
extendZodWithOpenApi(z);
// UUID validation
const uuidSchema = z.string().uuid('Invalid UUID format');
// Create course category input schema
export const CreateCourseCategorySchema = z
    .object({
    name: z
        .string()
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters')
        .trim()
        .openapi({
        description: 'Course category name',
        example: 'Medicine',
    }),
    slug: z.string().max(255, 'Slug must be less than 255 characters').openapi({
        description: 'Course category slug',
        example: 'medicine',
    }),
})
    .openapi('CreateCourseCategory');
export const UpdateCourseCategorySchema = z
    .object({
    name: z
        .string()
        .min(1, 'Name is required')
        .max(255, 'Name must be less than 255 characters')
        .trim()
        .optional()
        .openapi({
        description: 'Course category name',
        example: 'Medicine',
    }),
    slug: z.string().max(255, 'Slug must be less than 255 characters').optional().openapi({
        description: 'Course category slug',
        example: 'medicine',
    }),
})
    .openapi('UpdateCourseCategory');
// List courses query parameters
export const ListCourseCategoriesQuerySchema = z.object({
    page: z
        .string()
        .optional()
        .default('1')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0, 'Page must be greater than 0'),
    pageSize: z
        .string()
        .optional()
        .default('10')
        .transform((val) => parseInt(val, 10))
        .refine((val) => val > 0 && val <= 100, 'Page size must be between 1 and 100'),
    sortBy: z
        .enum(['name', 'slug', 'createdAt', 'updatedAt'])
        .optional()
        .default('createdAt')
        .openapi({
        description: 'Field to sort results by',
        example: 'createdAt',
    }),
    sortOrder: z.enum(['asc', 'desc']).optional().default('desc').openapi({
        description: 'Sort direction',
        example: 'desc',
    }),
});
// Course category ID parameter validation
export const CourseCategoryIdParamSchema = z.object({
    categoryId: uuidSchema.openapi({
        description: 'Unique identifier of the course category',
        example: '550e8400-e29b-41d4-a716-446655440000',
    }),
});
//# sourceMappingURL=course-category.schema.js.map